<template>
    <autocomplete v-model="valueLocal.value" :label="valueLocal.name" item-text="label" item-value="id" :url="'/api/' + value.apiMethod + '/Autocomplete'" />
</template>

<script>
    export default {
        props: [
            'value'
        ],
        components: {
            autocomplete: () => import('../components/Autocomplete')
        },

        computed: {
            valueLocal: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit("input", value);
                },
            },
        }
    }
</script>
